import { StyleSheet } from 'react-native';
import mixins from '@streamster/shared/app/styles';

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    color: mixins().color.input,
    fontSize: 22,
    marginBottom: mixins().indent.i6,
  },
  subSection: {
    display: 'flex',
    color: mixins().color.input,
    fontSize: 20,
    marginBottom: mixins().indent.i6,
  },
  page: {
    display: 'flex',
    color: mixins().color.input,
    fontSize: mixins().font.sectionFont,
    marginBottom: mixins().indent.i10,
    marginTop: mixins().indent.i8,
  },
  alert: {
    display: 'flex',
    color: mixins().color.input,
    fontSize: mixins().font.bigFont,
    marginBottom: mixins().indent.i5,
    justifyContent: 'center',
    textAlign: 'center',
  },
});

export default styles;
